/* eslint-disable @typescript-eslint/naming-convention */
import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { CustomModalComponentProps } from "components/Dialog/DialogProvider";
import IconClose from "@material-ui/icons/Close";
import { IconButton } from "@material-ui/core";
import ProBadge from "icons/pro-badge";
import { observer } from "mobx-react";
import { appStore } from "models";
import { getPriceString, getOriginPriceString } from "helpers/format";
import PaymentMethodForm from "./PaymentMethodForm";
import { createStripeCustomer, createSubscription } from "api/Checkout";
import { syncUserInfo } from "models/actions";

import "./index.scss";
import { STRIPE_KEY } from "config";

interface Props extends CustomModalComponentProps {
  lossPlan?: number;
}

const CheckoutModal: React.FC<Props> = ({ handleCancel, handleConfirm }) => {
  const handleSubmitPaymentMethod = async (paymentMethod) => {
    try {
      await createStripeCustomer(paymentMethod.id);
      await createSubscription(appStore.activeStripePlan.id);
      await syncUserInfo(true);
      handleConfirm();
    } catch (error) {
      appStore.setCheckoutFormError(error);
    }
  };

  return (
    <div className="modal-content checkout-modal-content">
      <IconButton className="btn-close-modal" onClick={handleCancel}>
        <IconClose></IconClose>
      </IconButton>
      <div className="modal-title">Checkout</div>
      <div className="modal-info-block your-plan">
        <div className="modal-info-block-title">Your plan</div>
        <div className="your-plan-box">
          <div className="plan-title">
            {"Healthi PRO"}
          </div>
          <div className="plan-price">
            {getPriceString(appStore.activeStripePlan)}
            <div className="plan-origin-price">
              {getOriginPriceString(appStore.activeStripePlan)}
            </div>
          </div>
          <ProBadge className="plan-bage-pro" />
        </div>
      </div>

      <Elements stripe={loadStripe(STRIPE_KEY)}>
        <PaymentMethodForm
          handleSubmitPaymentMethod={handleSubmitPaymentMethod}
          buttonText="upgrade now"
        />
      </Elements>
    </div>
  );
};

export default observer(CheckoutModal);
